import { useTheme } from '@evi/skins';
import { DefaultAreaChart } from '../themes/default/DefaultAreaChart.js';
import type { AreaChartDatum } from '../themes/default/DefaultAreaChart.js';
import { LuceTrendChart } from '../themes/luce/LuceTrendChart.js';

export interface TrendChartProps {
  data: AreaChartDatum[];
  height?: number;
  /** Y-axis + last-point label formatter. */
  formatY?: (n: number) => string;
}

/**
 * Theme-aware trend chart.
 *   Default → full area chart with soft green fill + axis labels.
 *   Luce    → oscilloscope-style line over a reticle grid, amber
 *             stroke with a soft glow, pulsing current-value dot, and
 *             minimal min/max labels. Replaces the recoloured
 *             Sparkline used previously.
 */
export function TrendChart({ data, height, formatY }: TrendChartProps) {
  const { theme } = useTheme();

  if (theme.id === 'luce') {
    const luceProps: Parameters<typeof LuceTrendChart>[0] = {
      data,
      ...(height !== undefined ? { height } : {}),
      ...(formatY ? { formatY } : {}),
    };
    return <LuceTrendChart {...luceProps} />;
  }

  const props: Parameters<typeof DefaultAreaChart>[0] = {
    data,
    ...(height !== undefined ? { height } : {}),
    ...(formatY ? { formatY } : {}),
  };
  return <DefaultAreaChart {...props} />;
}
